module.exports = __webpack_public_path__ + "img/entrance.e300b4dc.png";